import { render, staticRenderFns } from "./TiktokIcon.vue?vue&type=template&id=27eae85a"
import script from "./TiktokIcon.vue?vue&type=script&lang=js"
export * from "./TiktokIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports